var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-card-wrapper d-flex flex-grow-1",class:{ active: _vm.isActive }},[_c('div',_vm._g({staticClass:"game-card-content",class:{ 'auto-size': !_vm.width || !_vm.height },style:(_vm.coverStyle)},_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }